import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { useSession, signOut } = authClient;

/** Sends the magic link and returns an error string, or null on success. */
export async function sendMagicLink(email: string): Promise<string | null> {
  const { error } = await authClient.signIn.magicLink({
    email: email.trim().toLowerCase(),
    callbackURL: "/rsvp",
  });
  if (!error) return null;
  if (error.status === 429) return "Too many attempts. Give it a minute and try again.";
  return error.message ?? "We couldn't send that link. Try again?";
}
